import axios from 'axios';

const baseUrl = '/admin-api';

const loadRecords = async (params) => {
  const { sort, ...otherParams } = params;
  const { sortField, order } = sort;
  const sortReverse = sortField ? order === 'DESC' : undefined;
  const { data } = await axios.get(`${baseUrl}/getTenantAdmins`, {
    params: { ...otherParams, sortPredicate: sortField, sortReverse },
    timeout: 10_000,
  });
  const { admins, count, offset } = data;
  return { records: admins, numRecords: count, offset };
};

const saveRecord = async (item, isNew = false) => {
  try {
    const { data } = await axios.post(
      `${baseUrl}/upsertAdmin`,
      { user_email: item.user_email, role: item.role, isNew },
      { timeout: 10_000 }
    );
    return data;
  } catch (err) {
    throw new Error(err?.response?.data?.message);
  }
};

const removeRecord = async (item) => {
  await axios.post(`${baseUrl}/deleteAdmin`, { user_email: item.user_email }, { timeout: 10_000 });
};

const resendInvite = async (item) => {
  await axios.post(`${baseUrl}/resendInvite`, { user_email: item.user_email }, { timeout: 10_000 });
};

const getRoles = async () => {
  const { data } = await axios.get(`${baseUrl}/getAdminRoles`, { timeout: 10_000 });
  return data.roles;
};

const adminApi = {
  loadRecords,
  saveRecord,
  removeRecord,
  resendInvite,
  getRoles,
};

export default adminApi;
